import { initFeatureFlags } from '../../../feature-flags/redux/init';
import { getOptions } from '../../../feature-flags/config';
import { UserPermissionService } from '../../../services/user-permission-service';

export const launchDarklyFallback = (data) => {
  // oxlint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const { bootstrapFailed, seller, currentUser } = data.input;
      // if it hasn't failed then don't need to do anything. Resolve and go to the next step.
      if (!bootstrapFailed) {
        resolve({});
        return;
      }

      const { sellerId, subscriptionPlanInfo, homeCountry, createDateUtc } = seller;
      const { planCode, planName, isExpired } = subscriptionPlanInfo;

      const { userId, name, email, username, roles } = currentUser;

      const sellerCreateDateUtc = Date.parse(createDateUtc);

      const userProfile = {
        key: userId,
        name,
        email,
        country: homeCountry,
        custom: {
          userId,
          username,
          partition: window.location.hostname.split('.')[0],
          sellerId,
          isSystemAdmin: UserPermissionService.userHasAdministrationRole(roles),
          billingPlanName: planName,
          billingPlanCode: planCode,
          subscriptionExpired: isExpired,
          sellerCreateDateUtc,
        },
      };

      await initFeatureFlags({
        user: userProfile,
        ldOptions: getOptions({}),
        isBootstrapped: false,
      });

      resolve({});
    } catch (e) {
      reject(e);
    }
  });
};
